export default __webpack_public_path__ + "static/media/logo-horizontal.230e356f.png";